<Menu></Menu>

<main class="pt-6 p-3">
  <router-outlet />
</main>
